<div class="pieContainer" tooltip="{{ loadFactor | number:'1.0-0' | customNumberFormat }}%" placement="top">
  <div class="pieBackground {{theme$ | async}}"></div>
  @for (l of lf; track $index; let i = $index) {
    <div id="pieSlice{{i + 1}}" class="hold">
      <div class="pie" [ngStyle]="{'transform': 'rotate(' + l + 'deg)'}"></div>
    </div>
  }
</div>
